// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from "next/dynamic";

export const components = {
  cards: dynamic(() => import("./Cards")),
  carousel: dynamic(() => import("./Carousel")),
  contact: dynamic(() => import("./Contact")),
  energy_parformance: dynamic(() => import("./EnergyParformance")),
  footer_main: dynamic(() => import("./FooterMain")),
  hero: dynamic(() => import("./Hero")),
  map: dynamic(() => import("./Map")),
  menu_item: dynamic(() => import("./MenuItem")),
  numbers: dynamic(() => import("./Numbers")),
  product_information: dynamic(() => import("./ProductInformation")),
  property_list: dynamic(() => import("./PropertyList")),
  review: dynamic(() => import("./Review")),
  text_only: dynamic(() => import("./TextOnly")),
  wide_card: dynamic(() => import("./WideCard")),
};
